import { render } from "./Sospensione.vue?vue&type=template&id=407b7591"
import script from "./Sospensione.vue?vue&type=script&lang=js"
export * from "./Sospensione.vue?vue&type=script&lang=js"

import "./Sospensione.vue?vue&type=style&index=0&id=407b7591&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__